'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_StoreGroupView$$anon$4() {
  this.bz1 = null;
  this.bz2 = false;
}
export { $c_Lpresto_StoreGroupView$$anon$4 as $c_Lpresto_StoreGroupView$$anon$4 };
$p = $c_Lpresto_StoreGroupView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_StoreGroupView$$anon$4;
/** @constructor */
function $h_Lpresto_StoreGroupView$$anon$4() {
}
export { $h_Lpresto_StoreGroupView$$anon$4 as $h_Lpresto_StoreGroupView$$anon$4 };
$h_Lpresto_StoreGroupView$$anon$4.prototype = $p;
$p.P = (function() {
  if ((!this.bz2)) {
    this.bz1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bz2 = true;
  }
  return this.bz1;
});
var $d_Lpresto_StoreGroupView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_StoreGroupView$$anon$4, "presto.StoreGroupView$$anon$4", ({
  Sh: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_StoreGroupView$$anon$4 as $d_Lpresto_StoreGroupView$$anon$4 };
//# sourceMappingURL=presto.-Store-Group-View$$anon$4.js.map
